import mutations from './mutations'
import * as actions from './actions'
import state from './state'

export default { mutations, actions, state }



// WEBPACK FOOTER //
// ./src/plugins/loader/vuex/index.js